export const initialValues = {
  name: "",
  lastName: "",
  secondName: "",
  rfc: "",
  number: "",
  licenseNumber: "",
  consecutive: "",
  idStation: "",
  idDepartment: "",
  idJob: "",
  idContract: "",
  phone: "",
  email: "",
  idUnit: "",
  unitNumber: "",
  lat: 1,
  lng: 1,
  id: "",
  route: "",
  street_number: "",
  intNumber: "",
  postal_code: "",
  sublocality_level_1: "",
  locality: "",
  administrative_area_level_1: "",
  reference: "",
};

const rfcMaxLength = 13;

export const requiredValues = {
  name: {required: true},
  lastName: {required: true},
  rfc: {
    required: true,
    exactLength: rfcMaxLength,
    message: `RFC debe tener una longitud de ${rfcMaxLength} caracteres`,
  },
  number: {
    required: true,
    maxLength: 10,
  },
  consecutive: {required: true},
  idStation: {required: true},
  idDepartment: {required: true},
  idJob: {required: true},
  phone: {required: true},
  email: {required: true, isEmail: true},
  
  lat: {required: true},
  lng: {required: true},
  
  // CRM-3042: hay ubicaciones sin calle y numero en Google Maps, asi que
  // dejan de ser obligatorios para poder dar de alta a esos empleados.
  route: {required: false},
  street_number: {required: false},
  postal_code: {required: true},
  sublocality_level_1: {required: true},
  locality: {required: true},
  administrative_area_level_1: {required: true},
};